export default __webpack_public_path__ + "scene5_3_icona92f94.png";